import { useQuery } from "@apollo/client";
import { GET_TESTIMONIALS } from "../graphql/queries";

function About() {
  const { data } = useQuery(GET_TESTIMONIALS);

  return (
    <div>
      <h1 className="display-text" style={{ fontSize: 42, marginBottom: 24 }}>
        About
      </h1>
      <div className="about-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
        <img
          src="/images/portrait.jpg"
          alt="Peanut Butter and Jelly event decor"
          style={{ width: "100%", borderRadius: 20, objectFit: "cover", maxHeight: 480 }}
        />
        <div>
          <p className="body-text" style={{ marginBottom: 16 }}>
            <span className="nav-logo__peanut">Peanut Butter</span>
            <span className="nav-logo__jelly"> And Jelly</span> specializes in turning
            celebration dreams into beautifully styled reality. From weddings and baby
            showers to birthdays and corporate gatherings, we bring warmth, creativity,
            and meticulous care to every party we design.
          </p>
          <p className="body-text">
            Whether you envision a fully styled event or a single show-stopping detail,
            we partner with you at every step so your celebration feels as extraordinary
            as you imagined.
          </p>
        </div>
      </div>

      {data?.testimonials?.length > 0 && (
        <section style={{ marginTop: 48 }}>
          <h2 className="h1-text" style={{ marginBottom: 24 }}>What clients say</h2>
          <div className="services-grid">
            {data.testimonials.map((t: { id: string; clientName: string; quote: string; eventType?: string }) => (
              <blockquote key={t.id} className="service-card">
                <p className="body-text" style={{ fontStyle: "italic", marginBottom: 12 }}>
                  &ldquo;{t.quote}&rdquo;
                </p>
                <footer className="h2-text">
                  — {t.clientName}
                  {t.eventType && `, ${t.eventType}`}
                </footer>
              </blockquote>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

export default About;
